import * as React from "react";
import classNames from "classnames";

import Icon from "~/components/shared/Icon";

type Props = {
  children: React.ReactNode;
  to?: string;
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
};

export default class RowLink extends React.PureComponent<Props> {
  static displayName = "Panel.RowLink";

  render() {
    if (this.props.to) {
      return (
        <a
          href={this.props.to}
          className={classNames(
            "btn hover-bg-silver hover-black focus-black flex items-center p-4",
            this.props.className,
          )}
        >
          <div className="min-w-0 flex-auto">{this.props.children}</div>
          <Icon
            icon="chevron-right"
            className="dark-gray flex-none"
            style={{ height: 15, width: 15 }}
          />
        </a>
      );
    }

    return (
      <a
        href={this.props.href}
        onClick={this.props.onClick}
        className={classNames(
          "btn hover-bg-silver hover-black focus-black flex items-center px-4 py-2",
          this.props.className,
        )}
      >
        <div className="min-w-0 flex-auto">{this.props.children}</div>
        <Icon
          icon="chevron-right"
          className="dark-gray flex-none"
          style={{ height: 15, width: 15 }}
        />
      </a>
    );
  }
}
